import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function Audience() {
  return <section className="py-24 px-6 bg-slate-950" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-13">
          <FadeIn data-id="element-14">
            <div className="space-y-6" data-id="element-15">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-16">
                <span className="bg-green-500/10 p-2 rounded-full" data-id="element-17">
                  <Check className="text-green-500" data-id="element-18" />
                </span>
                Esto es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-19">
                {['Despiertas 2–4am y te cuesta volver a dormir', 'Sientes ansiedad, rumiación o alerta nocturna', "Estás cansada de improvisar, llorar en silencio o 'aguantar'", 'Quieres algo simple, rápido y aplicable hoy mismo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-300" data-id="element-20">
                    <Check className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-21" />
                    <span data-id="element-22">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-23">
            <div className="space-y-6 opacity-75" data-id="element-24">
              <h3 className="text-2xl font-bold text-slate-200 mb-6 flex items-center gap-3" data-id="element-25">
                <span className="bg-slate-800 p-2 rounded-full" data-id="element-26">
                  <X className="text-slate-400" data-id="element-27" />
                </span>
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-28">
                {['Tienes síntomas severos que requieren evaluación médica inmediata', 'Sospechas apnea del sueño o dolor que te despierta', "Buscas 'un milagro' o promesas médicas"].map((item, i) => <li key={i} className="flex items-start gap-3 text-slate-400" data-id="element-29">
                    <X className="w-5 h-5 text-slate-500 shrink-0 mt-0.5" data-id="element-30" />
                    <span data-id="element-31">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}